import React from 'react';

const embedYoutube = (url: string) => {
    return <div className='event-video container'>
        <div className='video-container'>
             <iframe className='embedded-video' src={url}></iframe>
        </div>
    </div>
}

const customVideo = (url: string) => {
    return (
        <div className='event-video container'>
            <div className='video-container'>
                <video className='video-block' controls>
                    <source src={url} type="video/mp4" />
                    Your browser does not support HTML video.
                </video>
            </div>
        </div>)
}
export const VideoBlock = (props: any) => {
    const { videourl } = props;

    // handle short youtube urls
    const youtubeFull = 'https://www.youtube.com/embed/';
    const youtubeShort = 'http://youtu.be/';
    const youtubeShortSec = 'https://youtu.be/';
    if (videourl.indexOf('youtu.be') > -1) {
        const url = videourl
            .replace( youtubeShort, youtubeFull )
            .replace(youtubeShortSec, youtubeFull);
        return embedYoutube(url)
    }
    // handle youtube.com/watch?v=... urls
    if ( videourl.indexOf('youtube.com')) {
        const url = videourl.replace('watch?v=', 'embed/')
        return embedYoutube(url)
    }
    // handle other videos
    if ( videourl) {
        return customVideo(videourl);
    }
    return null;
}
